(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/racing/game-engine/assets/javascripts/errors.js') >= 0) return;  svs.modules.push('/components/racing/game-engine/assets/javascripts/errors.js');
"use strict";


const errors = {
  INVALID_COUPON: 'INVALID_COUPON',
  INVALID_SELECTION: 'INVALID_SELECTION'
};
svs.racing.gameEngine.errors = errors;

 })(window);